import { joinPath } from '../../core/utils';
import type { BareMetalNodesBlockOptions, BareMetalNodesPaths } from './types';

export function resolveBareMetalNodesPaths(prefix: string, options?: BareMetalNodesBlockOptions): BareMetalNodesPaths {
  return {
    bmsNode: joinPath(prefix, 'bmsNode'),
    gpuName: joinPath(prefix, 'gpuName'),
    imageTags: joinPath(prefix, 'imageTags'),
  };
}
